export const player_classname = "player";

export enum PlayerState {
  IDLE = "state-idle",
  WALK = "state-walk",
  ATTACK = "state-attack",
  HIT = "state-hit",
  SPAWN = "state-spawn",
}

export enum PlayerDirection {
  UP = "dir-up",
  DOWN = "dir-down",
  LEFT = "dir-left",
  RIGHT = "dir-right",
}
